(function($, document, window, undefined) {
	$(function() {
      // dont redirect for a browser session if redirected via currency selector
      if(window.location.search.indexOf("noredirect") !== -1){
        sessionStorage.setItem('noredirect', true);
      }
      
      if((window.location.hostname.indexOf("myshopify.com") === -1) && !(sessionStorage.getItem('noredirect'))) {
		var redirect = localStorage.getItem("location-redirect"),
			$cselectorBox = $("#cselector"),
            $cselectorBoxClose = $cselectorBox.find('.close-btn'),
            $cselectorBoxContinue = $cselectorBox.find('.continue'),
            $cselectorContryList = $cselectorBox.find('#countries'),
            globalStoreRedirectCode = 'US',
			redirectFromCountries = "AD, AE, AF, AG, AI, AL, AM, AN, AO, AR, AT, AU, AW, AX, AZ, BA, BB, BD, BE, BF, BG, BH, BI, BJ, BL, BM, BN, BO, BQ, BR, BS, BT, BV, BW, BY, BZ, CA, CC, CD, CF, CG, CH, CI, CK, CL, CM, CN, CO, CR, CU, CV, CW, CX, CY, CZ, DE, DJ, DK, DM, DO, DZ, EC, EE, EG, EH, EL, ER, ES, ET, FI, FJ, FK, FO, FR, GA, GD, GE, GF, GG, GH, GI, GL, GM, GN, GP, GQ, GR, GS, GT, GW, GY, HK, HM, HN, HR, HT, HU, ID, IE, IL, IM, IN, IO, IQ, IR, IS, IT, JE, JM, JO, JP, KE, KG, KH, KI, KM, KN, KP, KR, KW, KY, KZ, LA, LB, LC, LI, LK, LR, LS, LT, LU, LV, LY, MA, MC, MD, ME, MF, MG, MK, ML, MM, MN, MO, MQ, MR, MS, MT, MU, MV, MW, MX, MY, MZ, NA, NC, NE, NF, NG, NI, NL, NO, NP, NR, NU, NZ, OM, PA, PE, PF, PG, PH, PK, PL, PM, PN, PS, PT, PY, QA, RE, RO, RS, RU, RW, SA, SB, SC, SD, SE, SG, SH, SI, SJ, SK, SL, SM, SN, SO, SR, SS, ST, SV, SX, SY, SZ, TC, TD, TF, TG, TH, TJ, TK, TL, TM, TN, TO, TR, TT, TV, TW, TZ, UA, UG, UM, US, UY, UZ, VA, VC, VE, VG, VN, VU, WF, WS, XK, YE, YT, ZA, ZM, ZW",
			europeCountries = "BE, BG, CZ, DK, DE, EE, IE, EL, ES, FR, GR, HR, IT, CY, LV, LT, LU, HU, MT, NL, AT, PL, PT, RO, SI, SK, FI, SE",
            forceRedirect = (true) ? true : false,
			//redirectUrl = "http://countryredirect.myshopify.com/pages/australian-store-example-of-redirect",
			countryTranslations = {
				"Sweden": "Sverige"
			},
			domain = "https://pro.ip-api.com/json/?key=Ty0hI1rpeRh0z7A",
			redirect = (typeof redirect == "string") ? JSON.parse(redirect) : {shown: false, date: null};

		var today = new Date(),
			prevDate = new Date(redirect.date),
			dayLength = 1000 * 24 * 60 * 60, // in milliseconds
			diffDate = today - prevDate;

		// display query again if localStorage is older than x days
		if( diffDate / dayLength > 0.00069)
			redirect.shown = false;
		

		if( !redirect.shown ) {
			$.ajax( {
				url: domain,
				type: 'POST',
				dataType: 'jsonp',
				success: function(location) {
                  	//console.log('location:', location, typeof(location));
					if (redirectFromCountries.indexOf(location.countryCode) !== -1) {
                      var countryName = (countryTranslations[location.country]) ? countryTranslations[location.country] : location.country;
                      var countryCode = location.countryCode;
                      if (europeCountries.indexOf(countryCode) !== -1){
                        countryCode = 'EU';
                      }
                      if(!forceRedirect) {
                      	$cselectorBox.show().addClass('showcs');
                        
                        var h_height = $('header').height();
                        $('#cart.mobile').css('margin-top',h_height);
                      }
                      var checkInList = $cselectorContryList.find('[data-contryCode="'+countryCode+'"]');
                      var foundCurCode = checkInList.length;
                      //$('#countries option[data-contryCode="HK"]').prop('selected', true);
                      if (foundCurCode > 0){
                        $('#countries option[data-contryCode="'+countryCode+'"]').prop('selected', true);
                        if(forceRedirect) {
                          $cselectorBoxContinue.click();
                        }
                      }
                      else{
                        // select global store
                        $('#countries option[data-contryCode="'+globalStoreRedirectCode+'"]').prop('selected', true);
                      }
					}
				}
			});

			// only save to local storage if the user doesn't want to be redirected.
			$cselectorBoxClose.off().on("click", function(e) {
				e.preventDefault();
				e.stopPropagation();
				$cselectorBox.hide();
				saveRedirect();
			});

            $cselectorBoxContinue.on("click", function(e) {
				e.preventDefault();e.stopPropagation();
              	redirectUrl= $("#cselector option:selected").val();
              	window.location.assign(redirectUrl);
			});

		} 

    }
      
	});
})(jQuery, document, window);

function saveRedirect(key, val) {
	var redirect = {
		shown: true,
		date: Date()
	};
	localStorage.setItem("location-redirect", (JSON.stringify(redirect)));
}